module.exports = __webpack_public_path__ + "d2dc17991a96b76cd7f4db7d50fb2b23.svg";